import axiosIns from '@/libs/axios'

export default {
  namespaced: true,
  state: {
  },
  getters: {
  },
  mutations: {

  },
  actions: {
    async fetchVendors() {
      return axiosIns.get('vouchers/vendors').then(res => res.data.data)
    },
    async patchVendor(_, { id, data }) {
      return axiosIns.patch(`vouchers/vendors/${id}`, data)
    },
    async addVendor(_, vendor) {
      return axiosIns.post('vouchers/vendors', vendor)
    },
  },
}
